import {Position, type InternalNode} from '@xyflow/react'

function getNodeCenter(node: InternalNode) {
  const width = node.measured?.width ?? 0
  const height = node.measured?.height ?? 0
  return {
    x: node.internals.positionAbsolute.x + width / 2,
    y: node.internals.positionAbsolute.y + height / 2
  }
}

export function getEdgeParams(source: InternalNode, target: InternalNode) {
  const sourceCenter = getNodeCenter(source)
  const targetCenter = getNodeCenter(target)

  const dx = targetCenter.x - sourceCenter.x
  const dy = targetCenter.y - sourceCenter.y

  const sourcePos = getClosestSide(dx, dy)
  const targetPos = getClosestSide(-dx, -dy)

  const sourceWidth = source.measured?.width ?? 0
  const sourceHeight = source.measured?.height ?? 0
  const targetWidth = target.measured?.width ?? 0
  const targetHeight = target.measured?.height ?? 0

  const sx = getHandleX(source.internals.positionAbsolute.x, sourceWidth, sourcePos)
  const sy = getHandleY(source.internals.positionAbsolute.y, sourceHeight, sourcePos)
  const tx = getHandleX(target.internals.positionAbsolute.x, targetWidth, targetPos)
  const ty = getHandleY(target.internals.positionAbsolute.y, targetHeight, targetPos)

  return {sx, sy, tx, ty, sourcePos, targetPos}
}

function getClosestSide(dx: number, dy: number): Position {
  const absDx = Math.abs(dx)
  const absDy = Math.abs(dy)

  if (absDy > absDx) {
    return dy > 0 ? Position.Bottom : Position.Top
  }
  return dx > 0 ? Position.Right : Position.Left
}

function getHandleX(nodeX: number, nodeWidth: number, position: Position): number {
  if (position === Position.Left) return nodeX
  if (position === Position.Right) return nodeX + nodeWidth
  return nodeX + nodeWidth / 2
}

function getHandleY(nodeY: number, nodeHeight: number, position: Position): number {
  if (position === Position.Top) return nodeY
  if (position === Position.Bottom) return nodeY + nodeHeight
  return nodeY + nodeHeight / 2
}
